import { Translator } from '../../models/product/book';

/*************
 * Tony Mody 
 **************/
export const TONY_MODY_EN: Translator = {
  name: "Tony Mody",
  bio: "Experienced translator specializing in Christian literature and spiritual texts."
};

export const TONY_MODY_AR: Translator = {
  name: "توني مودي",
  bio: "مترجم ذو خبرة متخصص في الأدب المسيحي والنصوص الروحية."
};
/*************
 * Sarah Essam
 **************/
export const SARAH_ESSAM_EN: Translator = {
  name: "Sarah Essam", 
  bio: "Professional translator with expertise in theological and devotional works."
};

export const SARAH_ESSAM_AR: Translator = {
  name: "سارة عصام", 
  bio: "مترجمة محترفة ذات خبرة في الأعمال اللاهوتية والتقوى."
};
/*************
 * Mira Markram
 **************/
export const MIRA_MAKRAM_EN: Translator = {
  name: "Mira Makram",
  bio: "Skilled translator with a focus on spiritual growth and Christian living literature."
};

export const MIRA_MAKRAM_AR: Translator = {
  name: "ميرا مكرم",
  bio: "مترجمة ماهرة تركز على النمو الروحي وأدب الحياة المسيحية."
};

// All available translators
export const ALL_TRANSLATORS = [TONY_MODY_EN, SARAH_ESSAM_EN, MIRA_MAKRAM_EN];